import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FirmaComponent } from "./firma";

type Entity = models.FirmaModel;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un FinalizarEntrega
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Segmentos: x => x.Segmentos.length > 0
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un FinalizarEntrega
*/
export class FinalizarEntregaEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    foto = (props: Props) => props.value.Foto;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    nombreImg = createSelectorRx(this.foto, foto => foto ? foto.NombreCompletoFoto.length < 100 ? foto.NombreCompletoFoto : foto.NombreCompletoFoto.substr(0, 96) + " ..." : "")

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    private handleOnFirmaChange = async (x: Entity) => {
        var cambio: Partial<Entity> = { Segmentos: x.Segmentos };
        const viejo = this.props.value;
        if (this.props.onChange)
            await this.props.onChange({ ...viejo, ...cambio });
    }

    private handleOnAgregarImg = async () => {
        const archivo = await kea.upload();
        if (archivo) {
            var aceptedExtensions = ["jpg", "jpeg", "png", "gif", "mpg", "mpeg"];
            const name = archivo.name;
            var nombre = archivo.name.split(".");
            var extension = nombre[nombre.length - 1].toLowerCase();
            if (aceptedExtensions.indexOf(extension) != -1) {
                const datos = await kea.blobToBase64(archivo);
                const tipo = archivo.type;
                const viejo = this.props.value;
                var cambio: Partial<Entity> = { Foto: { ContenidoFoto: datos, MimeType: tipo, NombreCompletoFoto: name } as models.FotoEntregaZERealizada };
                if (this.props.onChange)
                    await this.props.onChange({ ...viejo, ...cambio });
            } else {
                await kea.message("Solo se aceptan archivos .jpg, .jpeg, .png, .gif, .mpg, .mpeg");
            }
        }
    }

    private onDeleteImg = async () => {
        const viejo = this.props.value;
        var cambio: Partial<Entity> = { Foto: null };
        await this.props.onChange({ ...viejo, ...cambio });
    }

    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Capturar firma del cliente"
                fullScreen={true}
            >
                <div className="row">
                    <div className="col-md-12">
                        <FirmaComponent value={value} onChange={this.handleOnFirmaChange} />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-md-12">
                        <kea.Button style="success" onClick={this.handleOnAgregarImg} >Cargar imagen </kea.Button>
                        <br />
                        {this.nombreImg(this.props)}
                        <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={this.onDeleteImg} tooltip="Quitar imagen" />
                    </div>
                </div>
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/finalizar/finalizar.tsx